import { ReplaySubject, fromEvent } from 'rxjs';
import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import { map } from 'rxjs/operators';
import { DOCUMENT, CommonModule } from '@angular/common';

var CONVERSION_TYPES;
(function (CONVERSION_TYPES) {
    CONVERSION_TYPES["CURRENCY_BY_CREDIT"] = "CURRENCY_BY_CREDIT";
    CONVERSION_TYPES["CREDIT_BY_CURRENCY"] = "CREDIT_BY_CURRENCY";
})(CONVERSION_TYPES || (CONVERSION_TYPES = {}));
const NULL_REWARD_POINTS = {
    CONVERSION_FACTOR: 1,
    CONVERSION_RATE_TYPE: CONVERSION_TYPES.CREDIT_BY_CURRENCY,
    points: 0,
    selectedPoints: 0
};
const CUSTOM_EVENT_NAME = 'OnSelectedPointsRewards';
const SESSION_STORAGE_ITEM = 'rewardSession';

class AmRewardsPricingService {
    constructor(document) {
        this.document = document;
        this.rewardSessionSubject = new ReplaySubject(1);
        this._document = document;
        const value = this._getFromStorage();
        this.rewardSessionSubject.next(value);
        fromEvent(this.document, CUSTOM_EVENT_NAME).subscribe((event) => {
            this.rewardSessionSubject.next(event.detail);
        });
    }
    onChange(price) {
        return this.rewardSessionSubject.pipe(map(points => this._pointsToPricing(points, price)));
    }
    _getFromStorage() {
        const value = sessionStorage.getItem(SESSION_STORAGE_ITEM);
        if (!value) {
            return NULL_REWARD_POINTS;
        }
        return JSON.parse(value).slider || NULL_REWARD_POINTS;
    }
    _pointsToPricing(points, price) {
        const truncatedPoints = this._truncateSelectedPoints(points, price);
        const pointsInMoney = this._calculatePointsInMoney(truncatedPoints, points);
        return {
            totalPrice: price - pointsInMoney <= 0 ? 0 : price - pointsInMoney,
            selectedPoints: truncatedPoints
        };
    }
    _truncateSelectedPoints(points, price) {
        const truncatedPoints = this._calculateSelectPointTrucate(points) > price
            ? this._calculateSelectPointByPrice(price, points)
            : points.selectedPoints;
        return truncatedPoints;
    }
    _calculateSelectPointByPrice(price, points) {
        if (points.CONVERSION_RATE_TYPE === CONVERSION_TYPES.CURRENCY_BY_CREDIT) {
            return Math.floor(price * points.CONVERSION_FACTOR);
        }
        if (points.CONVERSION_RATE_TYPE === CONVERSION_TYPES.CREDIT_BY_CURRENCY) {
            return Math.ceil(price / points.CONVERSION_FACTOR);
        }
    }
    _calculateSelectPointTrucate(points) {
        if (points.CONVERSION_RATE_TYPE === CONVERSION_TYPES.CURRENCY_BY_CREDIT) {
            return points.selectedPoints / points.CONVERSION_FACTOR;
        }
        if (points.CONVERSION_RATE_TYPE === CONVERSION_TYPES.CREDIT_BY_CURRENCY) {
            return points.selectedPoints * points.CONVERSION_FACTOR;
        }
    }
    _calculatePointsInMoney(truncatedPoints, points) {
        if (points.CONVERSION_RATE_TYPE === CONVERSION_TYPES.CURRENCY_BY_CREDIT) {
            return truncatedPoints / points.CONVERSION_FACTOR;
        }
        if (points.CONVERSION_RATE_TYPE === CONVERSION_TYPES.CREDIT_BY_CURRENCY) {
            return truncatedPoints * points.CONVERSION_FACTOR;
        }
        return 0;
    }
}
AmRewardsPricingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmRewardsPricingService, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
AmRewardsPricingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmRewardsPricingService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmRewardsPricingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

class AmRewardsPricingServiceModule {
    constructor() { }
}
AmRewardsPricingServiceModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmRewardsPricingServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AmRewardsPricingServiceModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: AmRewardsPricingServiceModule, imports: [CommonModule] });
AmRewardsPricingServiceModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmRewardsPricingServiceModule, providers: [AmRewardsPricingService], imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmRewardsPricingServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    exports: [],
                    imports: [CommonModule],
                    providers: [AmRewardsPricingService],
                }]
        }], ctorParameters: function () { return []; } });

/*
 * Public API Surface of am-rewards-pricing
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AmRewardsPricingService, AmRewardsPricingServiceModule, CONVERSION_TYPES, CUSTOM_EVENT_NAME, NULL_REWARD_POINTS, SESSION_STORAGE_ITEM };
